import { render, staticRenderFns } from "./UnitsSummary.vue?vue&type=template&id=5314c1d9&scoped=true"
import script from "./UnitsSummary.vue?vue&type=script&lang=js"
export * from "./UnitsSummary.vue?vue&type=script&lang=js"
import style0 from "./UnitsSummary.vue?vue&type=style&index=0&id=5314c1d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5314c1d9",
  null
  
)

export default component.exports